<template>
    <b-form @change="emitForm">
        <b-row>

            <b-col cols="12">
                <b-form-group label="Additional Cost (Rs)" label-for="cost" label-cols-md="4">
                    <b-form-input id="cost" type="number" placeholder="Rs 6000" v-model="product.additionalCost"
                        @input="calculatePrice" />

                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group label="Previous Selling Price (Rs)"  label-for="price" label-cols-md="4">
                    <b-form-input id="price" type="number" placeholder="Rs 8280" v-model="PrevioussalePrice" readonly />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group label="New Selling Price (Rs)" label-for="price" label-cols-md="4">
                    <b-form-input id="price" type="number" placeholder="Rs 8280" v-model="product.salePrice" readonly />
                </b-form-group>
            </b-col>
        </b-row>

    </b-form>
</template>


<script>

import { BInputGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BFormGroup, BFormTextarea, BContainer, BFormSelect, BForm, BRow, BCol } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {

    components: {
        BFormTextarea,
        BFormSelect,
        BContainer,
        BInputGroup,
        BFormGroup,
        BFormInput,
        BInputGroupPrepend,
        BInputGroupAppend,
        BForm,
        BRow,
        BCol,
    },


    data() {
        return {
            PrevioussalePrice: null,
            price: {
                NewPrice: null,
                additionalCost: null,
            }
        }
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    watch: {
        product: {
            handler: 'productChanged',
            immediate: true,
        },
        'price.additionalCost': {
            handler: 'calculatePrice',
            immediate: true,
        },
    },
    computed: {
        ...mapGetters("productModule", {
            productID: "productID",
            loading: "loading",
        }),
    },
    mounted() {
        this.initializePrice();
    },
    methods: {
        ...mapActions("productModule", ["getProductIDAction"]),

        productChanged(newVal, oldVal) {
            if (newVal.itemId) {
                this.getProductIDAction(newVal.itemId).then(() => {
                    this.PrevioussalePrice = this.productID.salePrice;
                });
            }
        },
        initializePrice() {
            this.price.NewPrice = this.product.salePrice;
            this.price.additionalCost = this.product.additionalCost;
            this.emitForm();
          
        },


        emitForm() {
            this.$emit('price', this.price);
        },

        calculatePrice() {
            if (this.product.additionalCost === null || this.product.additionalCost === 0) {
                this.product.salePrice = this.PrevioussalePrice;
                this.price.NewPrice = this.PrevioussalePrice;
            } else {
                this.product.salePrice = Number(this.PrevioussalePrice) + Number(this.product.additionalCost);
                this.price.NewPrice = this.product.salePrice;
                this.price.additionalCost = this.product.additionalCost;
            }
        }
    },


}
</script>